import Cookies from "js-cookie";
//引入接口RouteConfig
import { RouteConfig } from "vue-router";
import layout from "@/views/layout/index.vue";

// 侧边栏状态
const sidebarStatusKey = "sidebar_status";
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) =>
  Cookies.set(sidebarStatusKey, sidebarStatus);

//路由处理
export const filterAsyncRoutes = (routes: RouteConfig[]) => {
  const accessedRoutes = routes.filter(route => {
   

    if (route.component) {
      if (route.component === "layout") {
        route.component = layout;
      } else {
        const component = route.component;
        route.component = () => import(`@/views/${component}`);
        // const component = route.path;
        // route.component = () => import(`@/views/baseAuth${component}`);
      }
    }
    if (route.children && route.children.length > 0) {
      // route.children.path = route.children.path.substr(1)
      route.children = filterAsyncRoutes(route.children);
    }
    return true;
  });
  return accessedRoutes;
};
